import {createLazyLoadTrigger} from "@/laraberg_frontend/general"

// Check document ready state and initialize the hero components
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroWithVideo)
} else {
    initHeroWithVideo()
}

// Function to initialize hero components with video functionality
function initHeroWithVideo() {
    const heroComponents = document.querySelectorAll(".wp-block-tutkit-hero-with-video")
    if (!heroComponents.length) return

    createLazyLoadTrigger(".wp-block-tutkit-hero-with-video", 200, async () => {
        heroComponents.forEach(function (component) {
            const playButtons = component.querySelectorAll(".icon-play")

            playButtons.forEach((button) => {
                button.addEventListener("click", function (e) {
                    e.preventDefault()

                    // Generate HTML structure for the video popup
                    const videoSrc = button.getAttribute("data-href")
                    if (!videoSrc) return // Safety check for video source

                    const popupHtml = `
                        <div class="popup-backdrop image canClose" style="width: 100%; height: 100%">
                            <div title="close" class="icon icon-close-dark pointer canClose close"></div>
                            <div class="container-image flex flex-center center">
                                <video controls autoplay controlsList="nodownload" style="width: 100%" src="${videoSrc}"></video>
                            </div>
                        </div>
                    `
                    const popupDiv = document.createElement("div")
                    popupDiv.className = "popup popup-blur popup-open popup-auto-width"
                    popupDiv.style.padding = "0px"
                    popupDiv.style.maxWidth = "none"
                    popupDiv.innerHTML = popupHtml
                    component.append(popupDiv)

                    // Add event listener to close the popup when the close button is clicked
                    const closeButton = component.querySelector(".close")
                    if (closeButton) {
                        closeButton.addEventListener("click", () => {
                            component.querySelector(".popup").remove()
                        })
                    }

                    // Add event listener to close the popup if clicked outside the video
                    document.addEventListener("mouseup", (e) => {
                        const containerImage = component.querySelector(".container-image")
                        if (containerImage && !containerImage.contains(e.target)) {
                            const popup = e.target.closest(".popup")
                            if (popup) popup.remove()
                        }
                    })

                    // Add event listener to close the popup when the escape key is pressed
                    document.addEventListener("keydown", (evt) => {
                        evt = evt || window.event
                        if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
                            const popup = component.querySelector(".popup")
                            if (popup) {
                                evt.stopPropagation()
                                popup.remove()
                            }
                        }
                    })
                })
            })
        })
    })
}
